import api from '../config/api';

// Fetch all slides
export const fetchAllSlideShow = async () => {
    const res = await api.get("/slideShow/");
    return res.data.data;   // backend returns { data: [...] }
};

// Fetch slide by ID
export const fetchSlideShowById = async (id) => {
    const res = await api.get(`/slideShow/?id=${id}`);
    return res.data.data?.[0];   // single object
};

// Create slide
export const createSlideShow = async (formData) => {
    const res = await api.post(`/slideShow/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
};

// Update slide
export const updateSlideShow = async (id, formData) => {
    // 🚨 If your backend expects POST for update:
    const res = await api.post(`/slideShow/?id=${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

    // If backend really supports PUT, just replace `post` with `put`
    return res.data;
};

// Delete slide
export const deleteSlideShow = async (id) => {
    const res = await api.delete(`/slideShow/?id=${id}`);
    return res.data;
};
